/**
 * Runtime registry for service provider constructors
 */
const SERVICE_PROVIDER_CTORS = {};
/**
 * Register a service provider constructor with the registry
 * @param service - The service identifier (e.g., Services.SALE)
 * @param ctor - The constructor for the service provider class
 */
function registerServiceProvider(service, ctor) {
    SERVICE_PROVIDER_CTORS[service] = ctor;
}

export { SERVICE_PROVIDER_CTORS, registerServiceProvider };
//# sourceMappingURL=ServiceProviderRegistry.js.map
